import clsx from 'clsx';
import { toFinite } from 'lodash';
import map from 'lodash/map';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { FunctionComponent, ReactElement, useMemo } from 'react';
import styles from './PlannedNav.module.scss';

export type PlannedNavTab = Record<
    string,
    {
        name: string;
        component?: ReactElement | null;
        href: string;
        search: string;
    }
>;

export type PlannedNavProps = {
    orgTitle: string | undefined;
};

export const PlannedNav: FunctionComponent<PlannedNavProps> = ({
    orgTitle,
}) => {
    const router = useRouter();
    const query = router.query;
    const orgId = toFinite(query.sectionOrg);
    const tabs: PlannedNavTab = useMemo(
        () => ({
            announces: {
                name: 'Закупки',
                href: `/purchases`,
                search: `?sectionOrg=${orgId}`,
            },
            plannedPurchases: {
                name: 'Планируемые закупки',
                href: `/planned-purchases`,
                search: `?sectionOrg=${orgId}`,
            },
        }),
        [orgId]
    );
    if (!orgId) {
        return null;
    }
    return (
        <div className={styles.nav}>
            {map(tabs, (tab) => (
                <Link key={tab.href} href={`${tab.href}${tab.search}`}>
                    <a
                        className={clsx(
                            styles.navItem,
                            router.route === tab.href && styles.active
                        )}
                    >
                        {tab.name}
                    </a>
                </Link>
            ))}
        </div>
    );
};
